// extracted by mini-css-extract-plugin
export default {"link":"sR-z","disabled":"tR-z"};